/**
 * Vite env bridge for shared code.
 *
 * Rationale:
 * - Vite exposes runtime env via import.meta.env, but shared non-Vite code (e.g. tests and
 *   tooling) is CommonJS and cannot directly reference import.meta.
 * - The React (Vite) entry publishes env to window.__SV_ENV at startup.
 * - This module provides a tiny accessor that reads from window.__SV_ENV at call time so there is
 *   no race on module import order.
 * - In tests, this module is mocked in test/vitest/vitest-setup.ts to provide deterministic
 *   values without relying on import.meta.
 */
type ViteEnvRecord = Record<string, string | undefined>;

// Always resolve lazily at call time to avoid race with when __SV_ENV is set.
export function getViteEnv(key: string): string | undefined {
  const env = (globalThis as unknown as { __SV_ENV?: ViteEnvRecord }).__SV_ENV;
  return env ? env[key] : undefined;
}
